// extracted by mini-css-extract-plugin
export var callCard = "_mb-0";
export var callMessageButton = "_mb-1";
export var helpIcon = "_mb-3";
export var helpIconContainer = "_mb-4";
export var verticalDivider = "_mb-2";